import React, { useState, useEffect } from 'react';
import { Carousel, Image } from 'antd';
import '../css/CertificateCarousel.css';
import certData from '../data/certificates.json';

const CertificateCarousel = ({ filterType, slidesToShow = 4, variant = 'full' }) => {
    // 狀態管理：判斷是否為手機裝置
    const [isMobile, setIsMobile] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            // 判斷寬度是否小於 480px
            const mobileStatus = window.innerWidth < 480;
            setIsMobile(mobileStatus);
        };

        // 1. 組件掛載時立即執行一次檢查
        checkMobile();
        setIsInitialized(true);

        // 2. 監聽視窗大小變化，確保轉向或縮放時同步
        window.addEventListener('resize', checkMobile);

        // 清除監聽器
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const filteredData = filterType
        ? certData.filter(item => item.type === filterType)
        : certData;

    // 若資料為空則不渲染
    if (!filteredData || filteredData.length === 0) return null;

    // 關鍵：使用 isMobile 作為 Key 的一部分
    // 當 isMobile 從初始 false 變為 true 時，Carousel 會被強制銷毀並重建
    const carouselKey = `carousel-${filterType}-${isMobile ? 'mobile' : 'desktop'}-${isInitialized}`;

    const variantClass = `cert-variant-${variant}`;

    const carouselProps = {
        dots: false,
        infinite: filteredData.length > 1,
        adaptiveHeight: true,
        // 如果偵測到是手機，強制設定 slidesToShow 為 1，否則使用傳入的參數
        slidesToShow: isMobile ? 1 : Math.min(filteredData.length, slidesToShow),
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: Math.min(filteredData.length, 3)
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: Math.min(filteredData.length, 2)
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className={`cert-slider-wrapper ${variantClass}`}>
            {/* 只有在初始化判斷完成後才渲染，避免首屏閃爍 */}
            {isInitialized && (
                <Carousel key={carouselKey} {...carouselProps}>
                    {filteredData.map((cert) => (
                        <div key={cert.id} className="cert-slide-item">
                            <div className="cert-image-container">
                                <Image
                                    src={require(`../images/CertificateSection/${cert.imgName}`)}
                                    alt={cert.title}
                                    preview={true}
                                    loading="lazy"
                                    className="cert-img"
                                />
                            </div>
                            <div className="cert-info">
                                <div className="content-en">{cert.title}</div>
                            </div>
                        </div>
                    ))}
                </Carousel>
            )}
        </div>
    );
};

export default CertificateCarousel;